import React, { useState } from 'react';
import { ICON_NEW } from '../extras/icons';
import MainContent from '../layout/MainContent';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { addRoomsAction } from '../../actions/roomsActions';
import RoomList from './rooms/RoomList';
import RoomForm from './rooms/RoomForm';
import AuthoritiesService from '../../services/AuthoritiesService';
import { PARAMETROS_CREAR } from '../../data/objects';
//Función principal
const Rooms = () => {
    //Inicializo el state local
    const [show, setShow] = useState(false);
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Tomo el store
    const authorities = useSelector(state => state.auth.authorities);
    //Manejo el insert
    const handleCreate = () => {
        //Llamo al dispatch
        dispatch( addRoomsAction(handleOpen) );
    }
    //Nodos
    const nodes = [];
    //Actions
    const actions = [{
        title: 'NUEVO',
        css: 'success',
        icon: <ICON_NEW className="fa-sm text-white-50" />,
        handle: handleCreate,
        granted: authorities && AuthoritiesService.hasPermission(authorities, PARAMETROS_CREAR)
    }];
    //Manejo la apertura de la ventana
    const handleOpen = () => {
        setShow(true);
    }
    //Manejo el cierre de la ventana
    const handleClose = () => {
        setShow(false);
    }
    //Renderizo
    return (
        <React.Fragment>
            <MainContent 
                title='Salas' 
                subtitle='Sistema' 
                nodes={nodes}
                actions={actions}
                component={RoomList}
                handleOpen={handleOpen}
                handleClose={handleClose}
            />

            <RoomForm
                show={show}
                handleClose={handleClose}
            />
        </React.Fragment>
    );
};

export default Rooms;